import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@fluentui/react';
import * as React from 'react';
export const ReviewQAContent = ({ QAs = [] })=>{
    return /*#__PURE__*/ _jsx(Stack, {
        tokens: {
            childrenGap: 14,
            padding: 1
        },
        children: QAs === null || QAs === void 0 ? void 0 : QAs.map((reviewQA, index)=>/*#__PURE__*/ _jsxs("div", {
                className: "reviewQAContent",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "reviewContentQuestion",
                        children: reviewQA.question
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "reviewContentAnswer",
                        children: reviewQA.answer
                    })
                ]
            }, `reviewQAContent-${index}`))
    });
};
